import React from 'react'
import SetTitle from '../../utils/set_title'
import ContentGenForm from './ContentGenForm'

export default function ContentGen() {
	SetTitle('Content Gen')
	return (
		<>
			<div className="bg-gradient-info secondary-page-title" >
				<div md={12} className="form-title">
					<i className="ni ni-align-left-2 text-white" style={{color: "white", fontSize: "35px"}}></i>
					<h1 className="page-title">
						Content Gen
					</h1>
				</div>
			</div>
			<div className="page-description">
				Partendo da un file excel di keyword fornite in input, per ciascuna recupera e riassume il contenuto dalle prime 5 posizioni in SERP per dare contesto all’AI. In ouput viene fornito un testo di categoria/articolo editoriale, generato attraverso un prompt mirato.
			</div>

			<ContentGenForm/>
		</>
	)
}